import { useState } from "react";
import { useClerk, useUser } from "@clerk/react";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordScreen({ onDone }) {
  const { user } = useUser();
  const { signOut } = useClerk();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const bad = f.next.length < 15 ? "At least 15 characters" : f.next !== f.again ? "The new passwords do not match" : f.next === f.current ? "Choose a different password" : "";
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      await user.updatePassword({ currentPassword: f.current, newPassword: f.next, signOutOfOtherSessions: true });
      await api.post("/me/password-changed");
      toast.success("Password saved. From now on sign in with your NEW password - if your browser saved the temporary one, update it.", { duration: 9000 });
      onDone();
    } catch (x) { setErr(x?.errors?.[0]?.longMessage || x?.errors?.[0]?.message || "Could not change the password"); } finally { setBusy(false); }
  };
  const field = (k, label) => (
    <div><Label htmlFor={`cp-${k}`}>{label}</Label><Input id={`cp-${k}`} type="password" autoComplete={k === "current" ? "current-password" : "new-password"} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`change-pw-${k}`} /></div>
  );
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="change-password-screen">
      <form onSubmit={submit} className="max-w-md w-full bg-white border rounded-2xl p-8 space-y-4 shadow-sm">
        <img src="/ace-logo.png" alt="ACE eSIGN" className="w-40" />
        <div className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-[var(--brand)]" /><h1 className="text-xl font-bold">Set your own password</h1></div>
        <p className="text-sm text-slate-600">Your administrator gave you a temporary password. Choose a new one before continuing. After this, the temporary password no longer works.</p>
        {field("current", "Temporary password")}
        {field("next", "New password")}
        {field("again", "Repeat new password")}
        {(err || (f.next && bad)) && <p className="text-sm text-red-700" role="alert" data-testid="change-pw-error">{err || bad}</p>}
        <Button type="submit" className="btn-brand w-full" disabled={busy || !f.current || !!bad} data-testid="change-pw-submit">{busy ? "Saving..." : "Save password"}</Button>
        <button type="button" className="text-sm text-slate-500 underline w-full" onClick={() => signOut()} data-testid="change-pw-signout">Sign out</button>
      </form>
    </div>
  );
}
